import { formatISO } from 'date-fns';
import { months } from 'src/constants';

export const formatObjectToISO = (dateObject = { year: null, month: null }) =>
  formatISO(
    new Date(
      dateObject.year,
      months.findIndex(month => month === dateObject.month)
    )
  );
